import { Search } from '@/lib/icons'

const DisabledSearchBar = () => {
    return (
        <button
            name='Search'
            type='button'
            aria-label='Search'
            className="search-trigger"
        >
            <Search className="text-light/50 mt-0.5" />
            <span className="hidden sm:block text-light/60 mt-0.5 text-sm" > Search </span>
            <kbd className="ml-auto hidden lg:inline-flex items-center mt-0.5 px-2 py-1 bg-light/10 rounded text-xs text-light/50" >
                ctrl + k
            </kbd>
        </button>
    )
}

export default DisabledSearchBar